var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPesetaSign(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 384 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M376 184H336C336 100.188 267.812 32 184 32H88C65.938 32 48 49.938 48 72V184H8C3.578 184 0 187.594 0 192S3.578 200 8 200H48V472C48 476.406 51.578 480 56 480S64 476.406 64 472V336H184C262.334 336 326.262 276.215 334.383 200H376C380.422 200 384 196.406 384 192S380.422 184 376 184ZM64 72C64 58.781 74.766 48 88 48H184C258.984 48 320 109 320 184H64V72ZM184 320H64V200H318.383C310.354 267.395 253.506 320 184 320Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPesetaSign);
export default __webpack_public_path__ + "static/media/peseta-sign.14a2f50b9345cf7b3138f98f3aa9409f.svg";
export { ForwardRef as ReactComponent };